import React from 'react';
import { Link } from 'react-router-dom';

export const PartnerInvitationStep3 = () => {
    return (
        <>
            <div className="container-xl-base py-2 mb-auto">
                <h1 className="h1 text-primary font-weight-bolder mb-4">Activation de votre compte</h1>
                <label className="h5 lh-copy mb-4" htmlFor="code">Votre compte est désormais actif.<br/>Veuillez cliquer sur le bouton "Terminer" pour vous connecter à l'espace Partenaire.</label>
                
                
                
            </div>
            <footer className="block mt-auto text-left w-100 rounded-inherit">
                <Link to="/auth/partner/signin" className="btn btn-primary px-md-gutter px-4">Terminer</Link>                
            </footer>
        </>
    )
}